import { Component, ViewEncapsulation, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'ups-pagination-control',
    template: require('./ups-pagination-control.component.html'),
    encapsulation: ViewEncapsulation.None
})

export class UpsPaginationControlComponent implements AfterViewInit {

    @Input() firstLabel: string = '';
    @Input() previousLabel: string = '';
    @Input() nextLabel: string = '';
    @Input() lastLabel: string = '';
    @Input() totalRecords: number = 0;

    public pages: number[] = [];
    activePage: number = 1;

    constructor(private cdr: ChangeDetectorRef) { }

    ngAfterViewInit() {
        this.pages = this.getArrayOfPage(this.totalRecords);
        this.cdr.detectChanges();
    }

    private getArrayOfPage(pageCount: number): number[] {
        let pageArray: number[] = [];
        if (pageCount > 0) {
            for (var i = 1; i <= pageCount; i++) {
                pageArray.push(i);
            }
        }
        return pageArray;
    }

}